import { UserState } from './user.model';

const userDefault: UserState = {
  data: null,
  pending: false,
  error: undefined,
};

export default userDefault;
